import IconStarRating from "@Icons/IconStarRating";
import Tooltip from "@Popover/components/Tooltip";
import IconInfoCircle from "@Icons/filledOutline/IconInfoCircle";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";

const ScoreWithStarDisplay = ({score, numberOfRatings}) => {
    const {
        reviews: reviewsLabel,
    } = useTranslation('c_profile')

    const roundAndConvert = (string: string) => (parseFloat(string).toFixed(1))
    const numberOfReviewsLabel = `${roundAndConvert(score)}  (${numberOfRatings} ${reviewsLabel})`

    return (
        <span className="gb--star-rating">
            <IconStarRating ratingValueWidth={parseFloat(score) * 10}/>
            <span
                className="gb--emphasize gb--emphasize-default"
            >
                {numberOfReviewsLabel}
            </span>
        </span>
    )
}

export default ScoreWithStarDisplay;